import { render, staticRenderFns } from "./EmailCapture.vue?vue&type=template&id=19844757&"
import script from "./EmailCapture.vue?vue&type=script&lang=js&"
export * from "./EmailCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports